import { DocumentSubType } from '@model/ftf-api.model';
import { createReducer, on } from '@ngrx/store';

import * as DocumentSubTypesActions from '../actions/document-subtypes.actions';

export interface DocumentSubTypesState {
  subtypes: DocumentSubType[];
  isLoaded: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
}

/**
 * The initial state for the document sub types feature.
 */
export const initialDocumentSubTypesState: DocumentSubTypesState = {
  subtypes: [],
  isLoaded: false,
  error: null,
};

/**
 * The reducer function for the document sub types feature.
 */
export const documentSubTypesReducer = createReducer(
  initialDocumentSubTypesState,
  on(DocumentSubTypesActions.loadDocumentSubTypesSuccess, (state, { subtypes }) => ({
    ...state,
    subtypes,
    isLoaded: true,
    error: null,
  })),
  on(DocumentSubTypesActions.loadDocumentSubTypesFailure, (state, { error }) => ({
    ...state,
    error,
  }))
);
